import * as React from "react";

export function Error({ message }) {
  return null;
}
